import { useState } from 'react'
import { MessageCircleMore } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import CandidateCommentModal from './CandidateCommentModal'
import { useIsCandidateAdmin, useIsOwnCandidate } from '../hooks'

type Props = {
  candidate: wowaudit.GuildCandidate
  className?: string
}

const CandidateCommentAction = ({ candidate, className }: Props) => {
  const isAdmin = useIsCandidateAdmin()
  const isOwn = useIsOwnCandidate(candidate)
  const canEdit = isAdmin || isOwn
  const [editing, setEditing] = useState(false)

  return (
    <>
      {editing && (
        <CandidateCommentModal
          candidate={candidate}
          onClose={() => setEditing(false)}
        />
      )}

      <Tooltip>
        <TooltipTrigger
          onClick={() => (canEdit ? setEditing(true) : null)}
          className={cn(
            'flex items-center justify-center p-2 md:p-1 shrink',
            className,
          )}
        >
          <MessageCircleMore
            size={14}
            className={candidate.comment ? '' : 'text-muted-foreground/20'}
          />
        </TooltipTrigger>
        <TooltipContent className='max-w-[50vw] whitespace-normal'>
          {candidate.comment || (
            <span className='opacity-70 italic'>
              {canEdit ? 'Click to add a comment' : 'No comment'}
            </span>
          )}
        </TooltipContent>
      </Tooltip>
    </>
  )
}

export default CandidateCommentAction
